/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createLocalStorageProvider } from '@jira/platform__browser-storage-providers/src/controllers/local-storage/index.tsx';

let resolveCachePromise: (result: Promise<undefined> | undefined) => void;
const cachePromise = new Promise<undefined>((resolve) => {
	resolveCachePromise = resolve;
});
export const CACHE_SCOPE_KEY = '__scope_key__';
export const CACHE_PREFIX = 'cache_prefix';
const TIMEOUT = 10000;

const promiseWithMaxExecutionTime = (ms: number, promise: Promise<undefined>) => {
	let id: ReturnType<typeof setTimeout>;
	const timeout = new Promise(
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		(resolve: (result: Promise<never>) => void, reject: (error?: any) => void) => {
			id = setTimeout(() => {
				const storage = createLocalStorageProvider(CACHE_PREFIX);
				storage.clearAll();

				reject(new Error(`Cache scope was not set within ${TIMEOUT}ms`));
			}, ms);
		},
	);

	return Promise.race([promise, timeout]).then((result) => {
		clearTimeout(id);
		return result;
	});
};

export const scopeGuard = (): Promise<undefined> =>
	promiseWithMaxExecutionTime(TIMEOUT, cachePromise);

const config = {
	devTools: false,
	scopes: {
		prev: null,
		current: null,
	},

	set(scopeKey: string): void {
		const storage = createLocalStorageProvider(CACHE_PREFIX);
		const scopeKeyInStorage = storage.get(CACHE_SCOPE_KEY);
		// init value
		if (this.scopes.prev === null && this.scopes.current === null) {
			if (scopeKeyInStorage) {
				// @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
				this.scopes.prev = scopeKeyInStorage;
				// @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
				this.scopes.current = scopeKeyInStorage;
			}
		}
		// same account id
		if (this.scopes.current !== scopeKey) {
			// diffrent account id
			if (this.scopes.current !== null) {
				// scope has changed during session
				storage.clearAll();
			}
			// @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
			this.scopes.prev = this.scopes.current;
			// @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
			this.scopes.current = scopeKey;
			// @browser-storage setter
			storage.set(CACHE_SCOPE_KEY, scopeKey);
		}

		// @ts-expect-error - TS7005 - Variable 'resolveCachePromise' implicitly has an 'any' type.
		resolveCachePromise();
	},

	get(): null {
		return this.scopes.current;
	},
} as const;

export default config;
